<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import { useStore, useMapGetter } from 'dashboard/composables/store';

import PageHeader from '../../SettingsSubPageHeader.vue';
import Input from 'dashboard/components-next/input/Input.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

// WhatsApp test inbox: no token nor number of its own — it replies through Winker's shared
// number. Only the name is asked here; the phone list is managed in the inbox settings.
const { t } = useI18n();
const store = useStore();
const router = useRouter();
const uiFlags = useMapGetter('inboxes/getUIFlags');

const channelName = ref('');
const isSubmitDisabled = computed(() => !channelName.value.trim());

const createChannel = async () => {
  if (isSubmitDisabled.value) return;

  try {
    const inbox = await store.dispatch('inboxes/createChannel', {
      name: channelName.value.trim(),
      channel: { type: 'whatsapp_test' },
    });

    router.replace({
      name: 'settings_inboxes_add_agents',
      params: { page: 'new', inbox_id: inbox.id },
    });
  } catch (error) {
    useAlert(
      error.message ||
        t('INBOX_MGMT.ADD.WHATSAPP_TEST_CHANNEL.API.ERROR_MESSAGE')
    );
  }
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.WHATSAPP_TEST_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.WHATSAPP_TEST_CHANNEL.DESC')"
    />
    <form class="flex flex-col gap-4 mx-0" @submit.prevent="createChannel">
      <Input
        v-model="channelName"
        :label="$t('INBOX_MGMT.ADD.WHATSAPP_TEST_CHANNEL.CHANNEL_NAME.LABEL')"
        :placeholder="
          $t('INBOX_MGMT.ADD.WHATSAPP_TEST_CHANNEL.CHANNEL_NAME.PLACEHOLDER')
        "
      />
      <div class="w-full">
        <NextButton
          :is-loading="uiFlags.isCreating"
          :disabled="isSubmitDisabled"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.WHATSAPP_TEST_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
